var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpcoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5,
    height: 20,
    viewBox: "0 0 5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 5,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillRule: "evenodd",
    d: "M2.5 5C3.8807373 5 5 3.8807373 5 2.5S3.8807373 0 2.5 0 0 1.1192627 0 2.5C.00384521 3.87908936 1.12091064 4.99615479 2.5 5zm0 2.5C1.1192627 7.5 0 8.6192627 0 10s1.1192627 2.5 2.5 2.5S5 11.3807373 5 10c-.00384521-1.37908936-1.12091064-2.49615479-2.5-2.5zM0 17.5C0 16.1192627 1.1192627 15 2.5 15c1.37908936.00384521 2.49615479 1.12091064 2.5 2.5C5 18.8807373 3.8807373 20 2.5 20S0 18.8807373 0 17.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpcoes);
export default __webpack_public_path__ + "static/media/opcoes.b1b8998c0ef7f17f456045b45a57ad21.svg";
export { ForwardRef as ReactComponent };